export const CATEGORY_TABS = [
  { value: 'all', label: 'All Courses', icon: 'bi-grid-fill' },
  { value: 'automatic', label: 'Automatic', icon: 'bi-car-front-fill' },
  { value: 'manual', label: 'Manual', icon: 'bi-gear-wide-connected' },
];

export const DURATION_BUCKETS = [
  { value: 'all', label: 'All Durations', test: null },
  { value: 'under-5', label: 'Under 5 Hours', test: (h) => h < 5 },
  { value: '5-15', label: '5 - 15 Hours', test: (h) => h >= 5 && h < 15 },
  { value: '15-30', label: '15 - 30 Hours', test: (h) => h >= 15 && h < 30 },
  { value: '30-plus', label: '30+ Hours', test: (h) => h >= 30 },
];

export const PRICE_BUCKETS = [
  { value: 'all', label: 'All Prices', test: null },
  { value: 'under-100', label: 'Under £100', test: (p) => p < 100 },
  { value: '100-300', label: '£100 - £300', test: (p) => p >= 100 && p < 300 },
  { value: '300-600', label: '£300 - £600', test: (p) => p >= 300 && p < 600 },
  { value: '600-plus', label: '£600+', test: (p) => p >= 600 },
];

export const SORT_OPTIONS = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'duration-asc', label: 'Duration: Short to Long' },
];

export const DEFAULT_FILTERS = {
  courseType: 'all',
  transmission: 'all',
  duration: 'all',
  price: 'all',
};

export function getCoursePrice(course) {
  const numeric = Number(`${course?.price ?? ''}`.replace(/[^0-9.-]/g, ''));
  return Number.isFinite(numeric) ? numeric : 0;
}

export function getCourseHours(course) {
  const practical = Number(course?.practical) || 0;
  const theory = Number(course?.theory) || 0;
  const total = practical + theory;
  if (total > 0) return total;

  const dayMatch = `${course?.title || ''}`.match(/(\d+)\s*-?\s*days?/i);
  if (dayMatch) return Number(dayMatch[1]) * 8; // rough estimate so day-based courses land in 30+ Hours

  return 0;
}

export function getCourseDurationBadge(course) {
  const practical = Number(course?.practical) || 0;
  if (practical > 0) return `${practical} HOUR${practical === 1 ? '' : 'S'}`;

  return null;
}

export function getCourseDaysLabel(course) {
  const dayMatch = `${course?.title || ''}`.match(/(\d+)\s*-?\s*days?/i);
  if (!dayMatch) return null;

  return `${dayMatch[1]} Day${dayMatch[1] === '1' ? '' : 's'}`;
}

export function getCourseTransmission(course) {
  return `${course?.cartype || ''}`.toLowerCase();
}
